module.exports = __webpack_public_path__ + "img/icon-form-field-option-checked.1e4cfb70.svg";